/**
 * The generic landscape the API returns as an activity's image when the row
 * has no photo of its own (explore-data's detail, list and discover
 * fallbacks). Shared so a web surface can tell "no photo" from a real one and
 * put up something better suited, as the transfer route pages do.
 */
export const ACTIVITY_IMAGE_PLACEHOLDER =
  "https://images.unsplash.com/photo-1469474968028-56623f02e42e";
